import component from '.';
/** @type {UICore.ComponentMeta} */
const TabPaneComponentMeta = {
  id: 'w-tab-pane',
  name: 'Tab卡某一页',
  category: '布局',
  visible: false,
  component,
  slots: [{
    id: 'default',
    containerRef: 'container'
  }],
  designerFlags: {
    allowFloating: false,
    allowAdjustWidth: false,
    allowAdjustHeight: false
  },
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'title',
      type: 'string',
      title: '页卡标题',
      default: '请设置页卡标题',
      ui: {
        type: 'exprInput',
        props: {
          type: 'interopable-string'
        }
      }
    }, {
      id: 'badgeText',
      type: 'string',
      title: '小标签文案',
      default: '',
      ui: {
        type: 'exprInput',
        props: {
          type: 'interopable-string'
        }
      }
    }]
  },
  getLayoutName(layout) {
    var _layout$props;
    return `Tab页卡（${((_layout$props = layout.props) === null || _layout$props === void 0 ? void 0 : _layout$props.title) || '未命名'}）`;
  }
};
export default TabPaneComponentMeta;
//# sourceMappingURL=meta.js.map
